import { globalApi, listenFirebase } from 'modules/App/globalApi'

export const maintenanceApi = globalApi.injectEndpoints({
  endpoints: (build) => ({
    listenIsUnderMaintenance: build.query({
      queryFn: () => ({ data: false }),
      onCacheEntryAdded: async (_, api) => {
        listenFirebase('creatorDashboardSettings/underMaintenance', api)
      },
    }),
    listenIsAdmin: build.query({
      queryFn: () => ({ data: false }),
      onCacheEntryAdded: async ({ userId }, api) => {
        listenFirebase(`internal/admins/${userId}`, api)
      },
    }),
  }),
})

export const { useListenIsUnderMaintenanceQuery, useListenIsAdminQuery } = maintenanceApi
